import React, { useContext, useEffect, useReducer } from 'react';
import { dishFullInfoReducer } from './dishFullInfoReducer';
import { AppContext, IAppContext } from 'appState/appContext';
import { DishFullInfoContext, dishFullInfoInitialState, TDishFullInfoVisibleForm } from './dishFullInfoContext';
import { DishesContext, IDishesContext } from '../../Dishes/dishesState/dishesContext';
import { DishFullInfoActionTypes } from './dishFullInfoActions';
import { IGetDishInfo, IItemDishesForGetInfo } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishInfo } from 'backend/dishes';

const DishFullInfoState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(dishFullInfoReducer, dishFullInfoInitialState);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { dishIDForFullInfo } = useContext<IDishesContext>(DishesContext);
	const { response, refetch, loading } = useFetchData<IGetDishInfo, string>(
		dishIDForFullInfo ? getDishInfo : null,
		dishIDForFullInfo,
	);

	const changeDishFullInfoVisibleForm = (value: TDishFullInfoVisibleForm) => {
		dispatch({
			type: DishFullInfoActionTypes.CHANGE_DISH_FULL_INFO_VISIBLE_FORM,
			payload: {
				visibleForm: value,
			},
		});
	};

	const setDishForFullInfo = (value: IItemDishesForGetInfo | null) => {
		dispatch({
			type: DishFullInfoActionTypes.SET_DISH_FOR_FULL_INFO,
			payload: {
				dish: value,
			},
		});
	};

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		refetch();

		return () => {
			setDishForFullInfo(null);
			changeDishFullInfoVisibleForm('mainForm');
		};
	}, [dishIDForFullInfo]);

	useEffect(() => {
		response && setDishForFullInfo(response.data.dish);
	}, [response]);

	return (
		<DishFullInfoContext.Provider
			value={{
				changeDishFullInfoVisibleForm,
				dishFullInfoVisibleForm: state.dishFullInfoVisibleForm,
				dishForFullInfo: state.dishForFullInfo,
			}}>
			{children}
		</DishFullInfoContext.Provider>
	);
};

export default DishFullInfoState;
